<section [ngClass]="{'isOnAi': isOnAi, 'default': !isOnAi && !isOnAnalysis && !isOnManipulation}"
  class="document_legend" aria-label="Document highlighting legend" focusable>
  <ng-container *ngIf="!isOnAi && !isOnAnalysis && !isOnManipulation">
    <ul class="legend-list">
      <li class="original_lang">
        <span class="legend-item">
          <img src="../../../../../../assets/report_v2/original_lang_v2.svg"
            alt="Two rows of two dots, with the first dot highlighted">{{ 'app.original_language' |translate }}
        </span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="Original">
            <img src="../../../../../../assets/report_v2/info.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.original_language_legend' | translate }}
          </div>
        </div>
      </li>

      <li class="translated_lang">
        <span class="legend-item"><img src="../../../../../../assets/report_v2/translated_lang_v2.svg"
            alt="Two rows of two dots, with the second dot highlighted">{{ 'app.upload.translated_language' | translate
          }}
        </span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="Translated language">
            <img src="../../../../../../assets/report_v2/info.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.translated_language_legend' | translate }}
          </div>
        </div>
      </li>

      <li class="ai" [class.hidden]="!isAiEnabled" *ngIf="isAiEnabled">
        <span class="legend-item"><img src="../../../../../../assets/report_v2/ai-authorship_v2.svg"
            alt="Two rows of two dots, with the third dot highlighted">{{ 'general.ai_authorship' | translate }}</span>
            <div class="legend-tooltip-container">
              <button type="button" class="legend-tooltip-trigger" aria-label="AI Authorship">
                <img src="../../../../../../assets/report_v2/info.svg" alt="" />
              </button>
              <div class="legend-tooltip-text" role="tooltip">
                <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
                {{ 'new_entries.ai_legend' | translate }}
              </div>
            </div>
      </li>

      <li class="manipulation" *ngIf="textManipulationEnable">
        <span class="legend-item"><img src="../../../../../../assets/report_v2/manipulations_icon_v2.svg"
            alt="Two rows of two dots, with the fourth dot highlighted">{{ 'new_entries.manipulations' | translate
          }}</span>
          <div class="legend-tooltip-container">
            <button type="button" class="legend-tooltip-trigger" aria-label="Manipulations">
              <img src="../../../../../../assets/report_v2/info.svg" alt="" />
            </button>
            <div class="legend-tooltip-text" role="tooltip">
              <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
              {{ 'new_entries.manipulation_legend' | translate }}
            </div>
          </div>
      </li>

    </ul>
  </ng-container>

  <ng-container *ngIf="isOnAi && !isOnManipulation && isAiEnabled">
    <ul class="legend-list">
      <li class="ai_authorship generated-text">
        <span class="legend-item">{{ 'metadata.ai_generated' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="AI Generated Content">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'aria-labels.ai_authorship_likelihood' | translate }}
          </div>
        </div>
      </li>
    </ul>
    <!-- <section class="ai_keywords" role="group">
      <div>
        <h5>AI Keywords</h5>
        <button matTooltipClass="new_report_tooltip persistent-tooltip"
          matTooltip="Refers to the specific keyword flagged in a sentence identified as potentially AI-generated"
          aria-label="Information about detected AI keywords">
          <img src="../../../../../../assets/report_v2/info-empty.svg"
            alt="Info Button to display a tooltip for AI keywords." />
        </button>
      </div>
    </section> -->
  </ng-container>

  <ng-container *ngIf="isOnAnalysis && !isOnManipulation">
    <ul class="legend-list legend-exact">
      <li class="exact_match">
        <span class="legend-item">{{ 'report.exact_match' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="Exact match">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.exact_match_description' | translate }}
          </div>
        </div>
      </li>
      <li class="possibly_altered">
        <span class="legend-item">{{ 'report.possibly_altered_text' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="more info on Altered text">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.altered_text_description' | translate }}
          </div>
        </div>
      </li>
      <li class="context_similarity" *ngIf="this.context_similarity">
        <span class="legend-item">{{ 'new_entries.contextual_similarity' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="more info on Contextual Similarity">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.contextual_similarity_legend' | translate }}
          </div>
        </div>
      </li>
      <li class="marked_quotation">
        <span class="legend-item">{{ 'new_entries.cited_text' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="Cited Text">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.properly_cited_sources' | translate }}
          </div>
        </div>
        <div class="toggle-button-wrapper" role="switch" [attr.aria-checked]="toggleChecked"
          [attr.aria-label]="toggleAriaLabel" tabindex="0" (click)="toggleQuotes()" (keydown)="onKeyDown($event)">
          <div class="custom-switch" [class.checked]="toggleChecked">
            <div class="switch-thumb"></div>
          </div>
        </div>
      </li>
      <li class="removed_highlight">
        <span class="legend-item">{{ 'report.excluded' | translate }}</span>
        <div class="legend-tooltip-container">
          <button type="button" class="legend-tooltip-trigger" aria-label="Excluded Text">
            <img src="../../../../../../assets/report_v2/info-empty.svg" alt="" />
          </button>
          <div class="legend-tooltip-text" role="tooltip">
            <span class="cdk-visually-hidden" [attr.aria-label]="'aria-labels.tooltip_prefix' | translate"></span>
            {{ 'new_entries.excluded_sentences' | translate }}
          </div>
        </div>
      </li>
    </ul>
  </ng-container>
</section>